import { put, takeLeading } from 'redux-saga/effects';

import extranetNotificationApi from 'api/extranetNotification';
import { apiErrorHandler } from 'utils';

import {
  GET_EXTRANET_NOTIFICATION,
  GET_EXTRANET_NOTIFICATION_SUCCESS,
  GET_EXTRANET_NOTIFICATION_FAILED,
  READ_EXTRANET_NOTIFICATION,
  READ_EXTRANET_NOTIFICATION_SUCCESS,
  READ_EXTRANET_NOTIFICATION_FAILED,
} from './actionTypes';

function* getExtranetNotification({ payload }) {
  try {
    const response = yield extranetNotificationApi.getExtranetNotification(payload);

    yield put({
      type: GET_EXTRANET_NOTIFICATION_SUCCESS,
      payload: response.payload,
    });
  } catch (error) {
    apiErrorHandler(error);

    yield put({
      type: GET_EXTRANET_NOTIFICATION_FAILED,
    });
  }
}

function* readExtranetNotification({ payload }) {
  try {
    const response = yield extranetNotificationApi.readExtranetNotification(payload);

    yield put({
      type: READ_EXTRANET_NOTIFICATION_SUCCESS,
      payload: response.payload,
    });
  } catch (error) {
    apiErrorHandler(error);

    yield put({
      type: READ_EXTRANET_NOTIFICATION_FAILED,
    });
  }
}

export default function* extranetNotificationSaga() {
  yield takeLeading(GET_EXTRANET_NOTIFICATION, getExtranetNotification);
  yield takeLeading(READ_EXTRANET_NOTIFICATION, readExtranetNotification);
}
